import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import axios from "axios";
import ElementUI from "element-ui";
import eleEn from "element-ui/lib/locale/lang/en";
import eleZh from "element-ui/lib/locale/lang/zh-CN";
import eleTw from "element-ui/lib/locale/lang/zh-TW";
import eleJa from "element-ui/lib/locale/lang/ja";
import "element-ui/lib/theme-chalk/index.css";
import VueCodemirror from "vue-codemirror";
import Antd from "ant-design-vue";
import { message } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import "codemirror/lib/codemirror.css";
import "babel-polyfill";
import "@/mixin";
import api from "@/api";
import $ from "jquery";
import VueAMap from "vue-amap";
import VueI18n from "vue-i18n";
import store from "@/vuex";

Vue.use(api);
Vue.use(Antd);
Vue.use(VueAMap);
Vue.use(VueI18n);
Vue.use(VueCodemirror);




// 初始化vue-amap
VueAMap.initAMapApiLoader({
    // 高德key jufang-web-js
    key: "49e3bcecc0af9528cc7665cb4a5eefd0",
    // 插件集合 （插件按需引入）
    plugin: [
        "AMap.Geolocation", //定经纬度地址
        "AMap.Geocoder", //获取详细地址
        "AMap.Autocomplete", //输入提示插件
        "AMap.PlaceSearch", //POI搜索插件
        "AMap.StationSearch", //公交搜索
        "AMap.Scale", //右下角缩略图插件 比例尺
        "AMap.OverView", //地图鹰眼插件
        "AMap.ToolBar", //地图工具条
        "AMap.MapType", //类别切换插件，实现默认图层与卫星图，实施交通图层之间切换的控制
        "AMap.PolyEditor", //编辑 折线多边形
        "AMap.CircleEditor", //图形编辑器插件
        // 'AMap.Driving', //驾车规划数据
        "MarkerClusterer" //点坐标聚合插件
    ]
});

const messages = {
    zh: Object.assign(require("./assets/lang/zh"), eleZh),
    en: Object.assign(require("./assets/lang/en"), eleEn),
    tw: Object.assign(require("./assets/lang/tw"), eleTw),
    ja: Object.assign(require("./assets/lang/ja"), eleJa)
};

const i18n = new VueI18n({
    locale: store.state.lang, // 语言标识
    messages
});

Vue.config.productionTip = false;
Vue.use(ElementUI, {
    size: "60",
    zIndex: 2000
});
Vue.prototype.$axios   = axios;
Vue.prototype.$message = message;
Vue.prototype.$bus     = new Vue();
Vue.prototype.$ipc     = require('@/mixin/ipcRender.js').default;


Vue.config.errorHandler = (err, vm, info) => vm.$api.reportAdminLog(err, vm, info);



new Vue({
    el: '#app',
    i18n,
    router,
    store,
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js